import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import LogoCarousel from '@segment/templates/LogoCarousel'
import { carouselLogos } from '@segment/templates/LogoCarousel/data'

const copy = {
  heading: `The world’s most innovative companies build winning customer experiences with Segment`,
}

const logos = [
  carouselLogos.THE_MOTLEY_FOOL,
  carouselLogos.CRYPTO_COM,
  carouselLogos.WEALTHSIMPLE,
  carouselLogos.CLEAR_SCORE,
  carouselLogos.CHIME,
  carouselLogos.EARNEST,
  carouselLogos.BETTER_MORTGAGE,
  carouselLogos.TAXFIX,
]

const LogoCarouselComponent = () => {
  return (
    <Wrapper>
      <StyledSectionBase variant="noCopy">
        <Section.Contents>
          <LogoCarousel heading={copy.heading} logos={logos} />
        </Section.Contents>
      </StyledSectionBase>
    </Wrapper>
  )
}

const Wrapper = styled.div``

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    padding-top: 40px;
    padding-bottom: 40px;

    ${({ theme }) => theme.breakpoints.up(`md`)} {
      padding-bottom: 60px;
    }
  }
`

export default LogoCarouselComponent
